import { CardProps, ICard } from '../../../store/quiz/interfaces'
import React, { FC } from 'react'

import BooleanCard from './BooleanCard'
import CardCard from './CardCard'
import CertificateCard from './CertificateCard'
import ChapterCard from './ChapterCard'
import CharmapCard from './CharmapCard'
import ChoiceCard from './ChoiceCard'
import ClozeCard from './ClozeCard'
import ClozeChoiceCard from './ClozeChoiceCard'
import CorrelationCard from './CorrelationCard'
import ImagePointerCard from './ImagePointerCard'
import MemoryCard from './MemoryCard'
import PasswordCard from './PasswordCard'
import { RootState } from '../../../store'
import { Row } from 'react-bootstrap'
import SequencingCard from './SequencingCard'
import TextCard from './TextCard'
import { useSelector } from 'react-redux'

const cardComponent = (card: ICard, mediaUrl: string) => {
  switch (card.type) {
    case 'chapter':
      return <ChapterCard card={card} mediaUrl={mediaUrl}></ChapterCard>
    case 'card':
      return <CardCard card={card} mediaUrl={mediaUrl}></CardCard>
    case 'text':
      return <TextCard card={card} mediaUrl={mediaUrl}></TextCard>
    case 'correlation':
      return <CorrelationCard card={card} mediaUrl={mediaUrl}></CorrelationCard>
    case 'cloze':
      return <ClozeCard card={card} mediaUrl={mediaUrl}></ClozeCard>
    case 'choice':
      return <ChoiceCard card={card} mediaUrl={mediaUrl}></ChoiceCard>
    case 'boolean':
      return <BooleanCard card={card} mediaUrl={mediaUrl}></BooleanCard>
    case 'clozechoice':
      return <ClozeChoiceCard card={card} mediaUrl={mediaUrl}></ClozeChoiceCard>
    case 'sequencing':
      return <SequencingCard card={card} mediaUrl={mediaUrl}></SequencingCard>
    case 'memory':
      return <MemoryCard card={card} mediaUrl={mediaUrl}></MemoryCard>
    case 'imagepointer':
      return (
        <ImagePointerCard card={card} mediaUrl={mediaUrl}></ImagePointerCard>
      )
    case 'certificate':
      return <CertificateCard card={card} mediaUrl={mediaUrl}></CertificateCard>
    case 'charmap':
      return <CharmapCard card={card} mediaUrl={mediaUrl}></CharmapCard>
    case 'password':
      return <PasswordCard card={card} mediaUrl={mediaUrl}></PasswordCard>
    default:
      return (
        <div>
          {card.type} - {card.title}
        </div>
      )
  }
}

const QuizCard: FC<Omit<CardProps, 'mediaUrl'>> = ({ card }) => {
  const { currentPage, data } = useSelector((state: RootState) => state.quiz)
  const page = data.pages[currentPage]
  const BASE_URL = window._env_.REACT_APP_MEDIA_BASE_URL
  const mediaUrl = `${BASE_URL}/uploads/images/${page.codename}/`

  return <Row>{cardComponent(card, mediaUrl)}</Row>
}

export default QuizCard
